export default [
  'obj', 'glb', 'fbx', '3dm', 'stl', 'ifc', 'dae', 'ply',
];